import { Grid, Stack } from '@mui/material';
import { Paths } from 'type-fest';
import { KeyboardDatePicker, KeyboardTimePicker } from '@occc-app/design-system';
import { LanguageIcon, Typography } from '@occc/ui-design-system';
import { readableTimezone } from '@occc-app/lib/format';

import { calculateDateTimeConstraints } from './calculateDateTimeConstraints';
import { ScheduleDatesFormValues } from './schemas/schedule-dates.schema';

const Timezone = () => {
  return (
    <Stack p={1.5} borderRadius={1} bgcolor='grey.200' direction='row' alignItems='center' gap={1}>
      <LanguageIcon color='primary' />
      <Typography>Time zone is set to {`${readableTimezone()}`}</Typography>
    </Stack>
  );
};

const defaultTimeSteps = { minutes: 1 };

type ScheduleDatesProps = {
  values: ScheduleDatesFormValues;
};

export const ScheduleDates = ({ values }: ScheduleDatesProps) => {
  const { minDate, maxDate, maxTime, minTime } = calculateDateTimeConstraints(values);

  return (
    <Grid container spacing={3}>
      <Grid container item xs={12} spacing={3}>
        <Grid item xs={12} sm={3} md={3}>
          <KeyboardDatePicker
            label='Start Date'
            name={'publishAtDate' satisfies Paths<ScheduleDatesFormValues>}
            disablePast
            maxDate={maxDate}
          />
        </Grid>

        <Grid item xs={12} sm={3} md={3}>
          <KeyboardTimePicker
            label='Start Time'
            name={'publishAtTime' satisfies Paths<ScheduleDatesFormValues>}
            ampm
            timeSteps={defaultTimeSteps}
            maxTime={maxTime}
          />
        </Grid>

        <Grid item xs={12} sm={3} md={3}>
          <KeyboardDatePicker
            label='End Date'
            name={'expireAtDate' satisfies Paths<ScheduleDatesFormValues>}
            minDate={minDate}
            disablePast
          />
        </Grid>

        <Grid item xs={12} sm={3} md={3}>
          <KeyboardTimePicker
            label='End Time'
            name={'expireAtTime' satisfies Paths<ScheduleDatesFormValues>}
            ampm
            timeSteps={defaultTimeSteps}
            minTime={minTime}
          />
        </Grid>
      </Grid>

      <Grid item xs={12} md={8}>
        <Timezone />
      </Grid>
    </Grid>
  );
};
